export default {
  title: 'Restaurantes de teste',
  description:
    'Cada parceiro pode marcar um restaurante como o seu restaurante de teste. Funciona como qualquer outro restaurante e nunca é faturado. É enviado um alerta no Slack quando as suas vendas do mês ultrapassam o limite.',
  empty: 'Nenhum parceiro tem um restaurante de teste.',
  columns: {
    partner: 'Parceiro',
    restaurant: 'Restaurante',
    designated: 'Marcado como teste',
    gmv: 'GMV este mês',
  },
  statuses: {
    live: 'Em direto',
    paused: 'Offline',
    suspended: 'Suspenso',
  },
  gmv: {
    converted: '≈ {{amount}}',
    no_rate: 'Sem taxa de câmbio guardada',
  },
  actions: {
    remove: 'Remover designação de Teste',
  },
  toasts: {
    load_error: 'Não foi possível carregar os restaurantes de teste.',
  },
};
